"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.YUSDOracleFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var YUSDOracleFactory = /** @class */ (function (_super) {
    __extends(YUSDOracleFactory, _super);
    function YUSDOracleFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    YUSDOracleFactory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    YUSDOracleFactory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    YUSDOracleFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    YUSDOracleFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    YUSDOracleFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return YUSDOracleFactory;
}(contracts_1.ContractFactory));
exports.YUSDOracleFactory = YUSDOracleFactory;
var _abi = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "BASE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "aaveRiskOracle",
        outputs: [
            {
                internalType: "contract IRiskOracle",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "chainlinkETHUSDAggregator",
        outputs: [
            {
                internalType: "contract IChainLinkAggregator",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "fetchCurrentPrice",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "value",
                        type: "uint256",
                    },
                ],
                internalType: "struct Decimal.D256",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "yUSDAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
var _bytecode = "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";
